
export default {
  data() {
    return {
      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "tags",
          label: "Tagovi (svaki tag odvojen sa |)",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
        {
          name: "image",
          label: "Screen",
          type: "image",
          size: "512x483",
        },
      ],
      activeItem: 0,
      activeItemWidth: 0,
    };
  },
  mounted() {
    this.updateActiveItemWidth();
    window.addEventListener("resize", this.updateActiveItemWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateActiveItemWidth);
  },
  methods: {
    setActiveItem(id) {
      this.activeItem = id;
      this.$nextTick(() => {
        this.updateActiveItemWidth();
      });
    },
    updateActiveItemWidth() {
      const activeElement = this.$el.querySelector(".active");
      if (activeElement) {
        this.activeItemWidth = activeElement.offsetWidth;
      }
    },
    getItemStyle(index) {
      if (this.activeItem === this.items[index].id) {
        return {
          transform: "translateX(0)",
        };
      } else if (this.items[index].id < this.activeItem) {
        return {
          transform: `translateX(-${
            (this.activeItem - this.items[index].id) * 8.3333
          }%)`,
        };
      } else {
        return {
          transform: `translateX(${
            (this.items[index].id - this.activeItem) * 66.6666
          }%)`,
        };
      }
    },
    setActiveItem(id) {
      this.activeItem = id;
    },
  },
};
